<template>
  <v-overlay :value="show" z-index="9999">
    <div class="story-viewer-wrapper" @click.self="close">
      <v-btn icon absolute top right class="mt-2 mr-2" @click="close"><v-icon large color="white">mdi-close</v-icon></v-btn>

      <div v-if="currentUser" class="story-content">
        <div class="progress-bar-container">
          <div v-for="(story, index) in currentUser.stories" :key="index" class="progress-bar">
            <div class="progress" :class="{ active: index === currentStoryIndex }" :style="{ animationDuration: storyDuration + 's' }"></div>
          </div>
        </div>

        <v-list-item dark class="px-3 user-info">
          <v-list-item-avatar><v-img :src="currentUser.bild"></v-img></v-list-item-avatar>
          <v-list-item-content
            ><v-list-item-title class="font-weight-bold">{{ currentUser.vorname }}</v-list-item-title></v-list-item-content
          >
        </v-list-item>

        <v-img :src="currentStory.image" contain height="80vh"></v-img>

        <div class="nav left" @click="prev"></div>
        <div class="nav right" @click="next"></div>
      </div>
    </div>
  </v-overlay>
</template>

<script>
export default {
  props: {
    show: Boolean,
    stories: Array,
    startIndex: Number,
  },
  data: () => ({
    currentUserIndex: 0,
    currentStoryIndex: 0,
    storyDuration: 5, // 5 Sekunden pro Story
    timer: null,
  }),
  computed: {
    currentUser() {
      return this.stories[this.currentUserIndex]
    },
    currentStory() {
      return this.currentUser?.stories[this.currentStoryIndex]
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.currentUserIndex = this.startIndex
        this.currentStoryIndex = 0
        this.startTimer()
      } else {
        this.stopTimer()
      }
    },
  },
  methods: {
    close() {
      this.$emit("update:show", false)
    },
    startTimer() {
      this.stopTimer()
      this.timer = setTimeout(this.next, this.storyDuration * 1000)
      // Force restart animation
      const activeProgress = this.$el.querySelector(".progress.active")
      if (activeProgress) {
        activeProgress.style.animation = "none"
        activeProgress.offsetHeight // Reflow
        activeProgress.style.animation = `fill-progress ${this.storyDuration}s linear forwards`
      }
    },
    stopTimer() {
      clearTimeout(this.timer)
    },
    next() {
      if (this.currentStoryIndex < this.currentUser.stories.length - 1) {
        this.currentStoryIndex++
        this.startTimer()
      } else {
        this.nextUser()
      }
    },
    prev() {
      if (this.currentStoryIndex > 0) {
        this.currentStoryIndex--
        this.startTimer()
      } else {
        this.prevUser()
      }
    },
    nextUser() {
      if (this.currentUserIndex < this.stories.length - 1) {
        this.currentUserIndex++
        this.currentStoryIndex = 0
        this.startTimer()
      } else {
        this.close()
      }
    },
    prevUser() {
      if (this.currentUserIndex > 0) {
        this.currentUserIndex--
        this.currentStoryIndex = 0
        this.startTimer()
      }
    },
  },
}
</script>

<style scoped>
.story-viewer-wrapper {
  width: 100vw;
  height: 100vh;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
}
.story-content {
  position: relative;
  width: 100%;
  max-width: 450px;
}
.progress-bar-container {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  display: flex;
  gap: 4px;
  z-index: 10;
}
.progress-bar {
  flex-grow: 1;
  height: 3px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}
.progress {
  height: 100%;
  background: white;
  border-radius: 2px;
  width: 0%;
}
.progress.active {
  animation: fill-progress 5s linear forwards;
}
@keyframes fill-progress {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
.user-info {
  position: absolute;
  top: 20px;
  left: 10px;
  z-index: 10;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), transparent);
}
.nav {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 30%;
  cursor: pointer;
}
.nav.left {
  left: 0;
}
.nav.right {
  right: 0;
}
</style>
